(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-pet-store"]) return;
  try {
    
  $(document).ready(function () {
    var inputs = document.getElementsByClassName('find-product-input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].scrollIndex = 100;
      inputs[i].items = item_list[i];
      let node = $('#' + inputs[i].id);
      node.autocomplete({
        source: function (req, response) {
          let term = $.ui.autocomplete.escapeRegex(req.term),
            matcher = new RegExp('^' + term, 'i'),
            matches = $.grep(node.prop('items'), function (item) {
              return matcher.test(item);
            });
          response(matches.slice(0, node.prop('scrollIndex')));
        },
        minLength: 0,
        messages: {
          noResults: '',
          results: function () {},
        },
      });

      let menus = document.getElementsByClassName('ui-autocomplete');
      inputs[i].menu = menus[i];
      inputs[i].menu.onscroll = function (e) {
        console.log(e.target.scrollTop);
        console.log(e.target.scrollHeight);
        if (e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight) {
          console.log('TEST');
          let scrollIndex = node.prop('scrollIndex');

          node.prop('scrollIndex', scrollIndex + 100);
          node.autocomplete('search', inputs[i].value);
        }
      };
      node.on('input', function () {
        console.log('INPUT');
        $(this).prop('scrollIndex', 100);
        $(this).prop('menu').scrollTop = 0;
      });

      node.on('click', function () {
        $(this).autocomplete('search', $(this).val());
        $(this).prop('menu').scrollTop = 0;
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
